import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useForgotPasswordViewController } from '../../controllers';

export const ForgotPasswordView = () => {
  const {
    emailSent,
    errors,
    formValues,
    getSupportEmail,
    handleChange,
    handleSendEmail,
    onKeyDown,
    navigateToLogin,
  } = useForgotPasswordViewController();

  return (
    <Stack direction="row" width="100%" height="100vh" alignItems="center" justifyContent="center">
      <Stack width={400} p={5} justifyContent="center">
        <Typography variant="h4" component="div" fontWeight="fontWeightSemiBold" mb={2}>
          Forgot Password
        </Typography>
        {!emailSent ? (
          <>
            <Box mb={4}>
              Enter the email associated with your account. We will email you a link to reset your
              password.
            </Box>
            <TextField
              onKeyDown={onKeyDown}
              id="outlined-basic"
              error={!!errors?.email}
              helperText={errors?.email || ''}
              label="Email Address"
              name="email"
              variant="outlined"
              value={formValues.email}
              onChange={handleChange}
            />
            <Button
              variant="contained"
              size="large"
              onClick={handleSendEmail}
              style={{ marginTop: '30px' }}
            >
              Send Link
            </Button>
          </>
        ) : (
          <>
            <Box mb={4}>Check Your Email</Box>
            <div>
              {`We're on it! If there's an account linked to this email address, you'll find an email from us with a password reset link shortly.
                    If you don't see our email within a few minutes, please check your spam or junk folder. For additional assistance, contact our support team `}
              <i>{getSupportEmail()}</i>.
            </div>
          </>
        )}
        <Link
          component="button"
          variant="body2"
          style={{ textAlign: 'right', marginTop: '8px' }}
          onClick={navigateToLogin}
        >
          Back to Login
        </Link>
      </Stack>
    </Stack>
  );
};
